import { useNavigate } from "react-router-dom"

import Style from "./style"

import MainHeader from "widget/MainHeader"
import Pagenation from "widget/Pagenation"

import useGetMediaList from "entity/media/useGetMediaList"
import useDeleteMedia from "entity/media/useDeleteMedia"

import TStyle from "shared/style/tableStyle"
import DefaultButton from "shared/ui/DefaultButton"
import timestampCalculator from "shared/lib/timestampCalculator"
import useConfirmModalAtom from "shared/model/useConfirmModalAtom"

const MediaList = () => {
    const navigate = useNavigate()

    const [mediaList] = useGetMediaList()
    const [deleteMedia] = useDeleteMedia()

    const [, setConfirm] = useConfirmModalAtom()

    const btnList = [
        {
            "label": "생성",
            "clickEvent": () => navigate("/media/create"),
            "deactive": false
        }
    ]
    const sizeList = ["short", "longlong", "longlonglong", "expand", "long", "medium"]
    const tableHeadList = ["IDX", "썸네일", "제목", "연결 링크", "생성 날짜", ""]

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList}>미디어 목록</MainHeader>

            <TStyle.TableDiv>
                <TStyle.TableRow $title>
                    {tableHeadList.map((elem, index) =>
                        <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                    )}
                </TStyle.TableRow>
                {mediaList?.data?.media_list?.map((elem, index) =>
                    <TStyle.TableRow $odd={index % 2 === 1} $exapnd>
                        <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                        <TStyle.Data $size={sizeList[1]}>
                            <Style.PreviewImg src={elem?.img} />
                        </TStyle.Data>
                        <TStyle.Data $size={sizeList[2]}>{elem?.title}</TStyle.Data>
                        <TStyle.Data $size={sizeList[3]}>{elem?.url}</TStyle.Data>
                        <TStyle.Data $size={sizeList[4]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                        <TStyle.Data $size={sizeList[5]}>
                            <DefaultButton small fitWidth clickEvent={() => navigate(`/media/${elem?.idx}/edit`)}>수정</DefaultButton>
                            <DefaultButton small fitWidth clickEvent={() => setConfirm("정말 삭제하시겠습니까?", () => () => deleteMedia(elem?.idx))}>삭제</DefaultButton>
                        </TStyle.Data>
                    </TStyle.TableRow>
                )}
            </TStyle.TableDiv>

            <Pagenation maxPage={mediaList?.data?.max_page} />
        </Style.Wrapper>
    )
}

export default MediaList